export default class FilterCategory {
  constructor(component) {
    this.dom = {
      $component: component,
      $categoryToggle: component.querySelector('.js-filterCategoryToggle'),
      $categoryOptions: component.querySelector('.js-filterCategoryOptions'),
    }
    this.state = {
      categoryOpen: true,
      categoryClosedClass: 'closedCategory',
    }
    this.categoryToggleHandler = this.categoryToggle.bind(this)

    this.mount()
    this.bindToWindow()
  }

  mount() {
    const { dom } = this
    dom.$categoryToggle.addEventListener('click', this.categoryToggleHandler)
  }

  categoryToggle() {
    const { dom, state } = this

    if (state.categoryOpen) {
      dom.$categoryOptions.setAttribute('aria-hidden', 'true')
      dom.$categoryOptions.setAttribute('aria-expanded', 'false')
      dom.$component.classList.add(state.categoryClosedClass)
      state.categoryOpen = false
    } else {
      dom.$categoryOptions.setAttribute('aria-hidden', 'false')
      dom.$categoryOptions.setAttribute('aria-expanded', 'true')
      dom.$component.classList.remove(state.categoryClosedClass)
      state.categoryOpen = true
    }
  }

  bindToWindow() {
    window.theme = window.theme || {}
    window.theme.FilterCategory = this
  }
}
